module.exports = __webpack_public_path__ + "img/thumbnail_TimberWolf_j_normal.69a1d254.png";